<div class="d-flex flex-column justify-content-center align-items-center p-0 m-0 mt-5 dirw-bg-loading"
    [style]="'--backgroundImg:url('+ profilePath +')'">
    <div class="text-center px-4">
        <div class="spinner-border text-secondary" style="width: 3rem; height: 3rem;" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <div class="mt-3 text-secondary text-center">
            <p>&nbsp;</p>
        </div>
    </div>
</div>